import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNTAttachmentData from '../../../state/nationalTeamAttachment/UseNTAttachmentData';

import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import usePersonNationalTeamFileTypeData from '../../../state/personNationalTeamFileType/UsePersonNationalTeamFileTypeData';

const INITIAL_STATE = {
  displayDeletePopup: false,
  deleteAttachmentObj: {}
};

const useProfilePublicAttachments = () => {
  const { navRoutes } = useNavRoutes();
  const { basePersonState } = useBasePersonData();
  const { personNationalTeamFileTypeState, getPersonNationalTeamAttachmentFileTypes } = usePersonNationalTeamFileTypeData();
  const {
    nationalTeamAttachmentState,
    nationalTeamAttachmentDeleteState,
    getNTAttachmentsByPersonId,
    deleteNTAttachment,
    clearNationalTeamAttachmentArrayData } = useNTAttachmentData();
  const [state, setState] = useState(INITIAL_STATE);

  const navigate = useNavigate();

  const onAddAttachmentClicked = (event) => {
    event?.preventDefault();

    navigate(navRoutes.MEMBER_PROFILE_PUBLIC_ATTACHMENT_DETAIL?.route);
  };

  const onEditAttachmentClicked = (event, attachmentObj) => {
    event?.preventDefault();

    navigate(navRoutes.MEMBER_PROFILE_PUBLIC_ATTACHMENT_DETAIL?.route, { state: { attachmentObj } });
  };

  const onDeleteAttachmentClicked = (event, attachmentObj) => {
    event?.preventDefault();

    setState({
      ...state,
      displayDeletePopup: true,
      deleteAttachmentObj: attachmentObj
    });
  };

  const onDeletePopupConfirmClicked = async (event) => {
    event?.preventDefault();

    const attachmentId = state.deleteAttachmentObj.personNationalAttachmentId;
    const attachmentUrl = state.deleteAttachmentObj.attachmentUrl;
    const isPublic = personNationalTeamFileTypeState.arrayData.find(x => x.personNationalAttachmentFileTypeId === state.deleteAttachmentObj.personNationalAttachmentFileTypeId)?.isPublicType === true;

    setState({ ...INITIAL_STATE });

    const deleteNTAttachmentResult = await deleteNTAttachment(attachmentId, attachmentUrl, isPublic);

    if (deleteNTAttachmentResult) {
      getNTAttachmentsByPersonId(basePersonState.objData.personId, true);
    }
  };

  const onPopupCancelClicked = (event) => {
    event?.preventDefault();

    setState({ ...INITIAL_STATE });
  };

  useEffect(() => {
    if (basePersonState.isObjLoaded === true) {
      clearNationalTeamAttachmentArrayData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (nationalTeamAttachmentState.isArrayLoaded === false && basePersonState.isObjLoaded === true) {
      getNTAttachmentsByPersonId(basePersonState.objData.personId, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePersonState, nationalTeamAttachmentState]);

  useEffect(() => {
    if (!personNationalTeamFileTypeState.isArrayLoaded) {
      getPersonNationalTeamAttachmentFileTypes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personNationalTeamFileTypeState.isArrayLoaded]);

  return {
    isSaving: nationalTeamAttachmentDeleteState.isObjLoading,
    isLoading: nationalTeamAttachmentState.isArrayLoading || personNationalTeamFileTypeState.isArrayLoading,
    gridData: nationalTeamAttachmentState.arrayData || [],
    state,
    nationalTeamAttachmentState,
    onAddAttachmentClicked,
    onEditAttachmentClicked,
    onDeleteAttachmentClicked,
    onDeletePopupConfirmClicked,
    onPopupCancelClicked
  };
}

export default useProfilePublicAttachments;